import { StringKey } from '../../../lang/index';
import { PageRoute } from '../../../types/page.types';
import { DataRoomTab } from '../types/data-room.types';

export type DataRoomTabConfig = {
  id: DataRoomTab;
  path: PageRoute;
  title: StringKey;
};

export const DATA_ROOM_TABS: DataRoomTabConfig[] = [
  {
    id: DataRoomTab.ACTIVITY,
    path: PageRoute.DATA_ROOM_ACTIVITY,
    title: 'DATA_ROOM_ACTIVITY',
  },
  {
    id: DataRoomTab.WORKSPACES,
    path: PageRoute.DATA_ROOM_WORKSPACES,
    title: 'WORKSPACES',
  },
];
